<template>
  <div>
    <div
      class="
        is-flex is-justify-content-center is-align-items-center
        has-text-centered
      "
      v-if="dataSource && dataSource.length == 0"
      style="height: 500px"
    >
      <div class="has-text-centered">
        <div
          style="
            width: 60px;
            height: 60px;
            position: relative;
            margin: 20px auto;
          "
        >
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
          >
            <div
              class="my-1 mr-2"
              style="width: 20%; height: 10px; background-color: #f2f2f2"
            ></div>
            <div
              class="my-1"
              style="width: 80%; height: 10px; background-color: #f2f2f2"
            ></div>
          </div>
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
          >
            <div
              class="my-1 mr-2"
              style="width: 20%; height: 10px; background-color: #f2f2f2"
            ></div>
            <div
              class="my-1"
              style="width: 80%; height: 10px; background-color: #f2f2f2"
            ></div>
          </div>
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
          >
            <div
              class="my-1 mr-2"
              style="width: 20%; height: 10px; background-color: #f2f2f2"
            ></div>
            <div
              class="my-1"
              style="width: 80%; height: 10px; background-color: #f2f2f2"
            ></div>
          </div>
        </div>
        <p class="has-text-grey">
          Select your preference filter and click generate
        </p>
      </div>
    </div>
    <div v-else>
      <div class="is-flex is-justify-content-space-between">
        <div class="mb-5" style="width: 250px">
          <div class="is-flex">
            <button
              class="button is-small btn-light"
              style="width: 100px"
              :disabled="dataSource.length == 0"
              @click="handleSelectAll"
            >
              <input
                class="mr-2"
                type="checkbox"
                :disabled="dataSource.length == 0"
                :checked="isCheckedAll"
              />
              <span> Select All</span>
            </button>
            <div
              class="dropdown mr-1"
              :class="activeDropdown && 'is-active'"
              @mouseleave="handleDropwdownActions(false)"
              style="width: 100px"
            >
              <div class="dropdown-trigger">
                <button
                  :disabled="!isAction"
                  class="button is-small btn-light"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu"
                  @click="handleDropwdownActions(!activeDropdown)"
                >
                  <span>Actions</span>
                  <span class="icon is-small">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
              <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content">
                  <a class="dropdown-item" @click="handleRevoke">
                    <i class="fa fa-trash mr-2"></i>Remove
                  </a>
                  <a class="dropdown-item" @click="handleExport">
                    <i class="fa fa-file mr-2"></i> Downloaded As Excel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%">
          <div class="field">
            <p class="control has-icons-left has-icons-right">
              <input
                class="input is-small custom-input"
                placeholder="Searching"
                v-model="searchQuery"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-search"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="table-container custom">
        <loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="false"
        >
        </loading>

        <table class="custom-table" style="font-size: 12px">
          <tr>
            <th
              style="width: 50px"
              class="standard-col is-border-y is-border-x has-text-centered"
            >
              #
            </th>
            <th
              style="width: 70px"
              class="standard-col is-border-y is-border-x has-text-centered"
            >
              Select
            </th>
            <th class="standard-col is-border-y is-border-x">Student</th>
            <th
              class="standard-col is-border-y is-border-x"
              style="width: 150px"
            >
              Behavior
            </th>
            <th
              class="standard-col is-border-y is-border-x"
              style="width: 150px"
            >
              Total Points
            </th>
            <th class="standard-col is-border-y is-border-x">Remarks</th>
            <th class="standard-col is-border-y is-border-x">Remarks2</th>
            <th class="standard-col is-border-y is-border-x">Image</th>
            <th class="standard-col is-border-y is-border-x">Location</th>
            <th class="standard-col is-border-y is-border-x">Awarded by</th>
            <th class="standard-col is-border-y is-border-x">Actions</th>
          </tr>
          <!-- <tbody @scroll="onScroll"> -->
          <tr v-for="(data, index) in submissionData" :key="index + 1">
            <td
              class="standard-col is-border-y is-border-x has-text-centered"
              style="vertical-align: middle"
            >
              {{ startIndex + index }}
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="vertical-align: middle"
            >
              <div
                class="is-flex is-justify-content-center is-align-items-center"
              >
                <input
                  type="checkbox"
                  :checked="data.checked"
                  @click="handleSelect(data._id)"
                />
              </div>
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="vertical-align: middle"
            >
              <h6 class="mb-1">{{ data.studentName }}</h6>
              <p>{{ data.class }}</p>
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="vertical-align: middle"
            >
              <div v-if="selectedIndex != index">
                <h6 class="mb-1">
                  {{
                    behaviorDataSource.find((x) => x.value == data.positiveID)
                      .label
                  }}
                </h6>
                <p>{{ d(data.actionDate) }}, {{ data.actionTime }}</p>
              </div>
              <div v-else class="is-flex is-align-items-center">
                <InputCalender
                  :value="data.actionDate"
                  :change="handleDropdownChange"
                  :type="'day'"
                />
              </div>
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="vertical-align: middle"
            >
              <div v-if="selectedIndex != index">
                {{ data.points }} x {{ data.multiply }} =
                <b>{{ roundTo2DecimalPlaces(data.totalPoints) }}</b>
              </div>
              <div
                v-else
                class="is-flex is-align-items-center"
                style="padding-top: calc(0.5em - 1px)"
              >
                <p class="mb-0 mr-2">{{ data.points }} x</p>
                <input
                  class="input is-small"
                  v-model="multiplyValue"
                  type="number"
                  min="1"
                  :max="data.scaleLimit == -1 ? 1 : data.scaleLimit" 
                  style="width: 50px; padding: 12px 6px 11px 6px"
                />
                <p class="mb-0 ml-2">=</p>
                <p class="mb-0 mr-2 ml-2">
                  <b>{{ data.points * multiplyValue }}</b>
                </p>
              </div>
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="padding-bottom: 0.8rem; vertical-align: middle"
            >
              <div>
                {{ displayInfo(data) }}
              </div>
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="padding-bottom: 0.8rem; vertical-align: middle"
            >
              <div>
                {{ !data.remarks2 ? "-" : data.remarks2 }}
              </div>
            </td>
            <td
              class="hstandard-col is-border-y is-border-x"
              style="padding-bottom: 0.8rem; vertical-align: middle"
            >
              <a
                v-if="data.image01 && data.image01.length > 3"
                style="cursor: pointer"
              >
                <i
                  class="fa fa-picture-o fa-3x"
                  v-on:click="viewImage(data.image01)"
                ></i>
              </a>
              <div v-else style="vertical-align: middle">-</div>
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="padding-bottom: 0.8rem; vertical-align: middle"
            >
              <div v-if="data.latlngLabel && data.latlngLabel.length > 3">
                <!-- <b-button
                  type="is-link is-light is-small"
                  v-on:click="viewLocation(data.latlng)"
                  >{{ data.latlngLabel }}</b-button
                > -->
                <a v-on:click="viewLocation(data.latlng)">{{
                  data.latlngLabel
                }}</a>
              </div>
              <div v-else style="vertical-align: middle">-</div>
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="padding-bottom: 0.8rem; vertical-align: middle"
            >
              {{ data.teacherName }}
            </td>
            <td
              class="standard-col is-border-y is-border-x"
              style="vertical-align: middle"
            >
              <div
                class="is-flex is-justify-content-center is-align-items-center"
              >
                <button
                  v-if="selectedIndex != index"
                  class="button is-small is-light"
                  @click="handleEdit(data, index)"
                >
                  <i class="fa fa-pencil"></i>
                </button>
                <div :style="selectedIndex == index && 'max-width: 80px'">
                  <button
                    v-if="selectedIndex == index"
                    class="button is-small is-white is-success"
                    @click="handleSave(data, index)"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    v-if="selectedIndex == index"
                    class="button is-small is-white is-danger"
                    @click="handleCancel"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div class="columns is-desktop" v-if="dataSource.length > 0">
        <div class="column">
          <div>
            <p
              class="
                is-flex is-justify-content-flex-start is-align-items-center
                m-0
                mr-3
                ml-3
                is-size-7
              "
            >
              {{ renderTotalTable }}
            </p>
          </div>
        </div>
        <div class="column">
          <div
            v-if="getTotalPage(currentPage).length != 1"
            class="is-flex custom-justify-center is-align-items-center"
          >
            <button
              style="border: 0px"
              class="button is-small mr-1 ml-1"
              :disabled="currentPage == 1"
              @click="
                handleChandePaginationSize('currentPage', currentPage - 1)
              "
            >
              Previous
            </button>
            <span v-for="pg in getTotalPage(currentPage)" :key="pg">
              <button
                style="border: 0px"
                class="button is-small mr-1 ml-1"
                :class="pg == currentPage && 'is-primary'"
                @click="handleChandePaginationSize('currentPage', pg)"
                :disabled="pg == currentPage"
              >
                {{ pg }}
              </button>
            </span>
            <button
              class="button is-small mr-1 ml-1"
              :disabled="currentPage == getTotalPage(currentPage).length"
              style="border: 0px"
              @click="
                handleChandePaginationSize('currentPage', currentPage + 1)
              "
            >
              Next
            </button>
          </div>
        </div>
        <div class="column">
          <div class="is-flex custom-justify-end is-align-items-center">
            <p class="m-0 ml-3 is-size-7 mr-2" style="padding-bottom: 0.1rem">
              Row per page:
            </p>
            <Dropdown
              style="width: 70px"
              customStyle="border: 0px; padding-left: 0px"
              name="currentLimit"
              Title="Page size"
              :dataSource="dataPageSize"
              :value="currentLimit"
              :change="handleChandePaginationSize"
              :position="true"
            />
          </div>
        </div>
      </div>
      <div v-else class="has-text-centered has-text-grey-light">No Data</div>
    </div>
  </div>
</template>

<script>
import { displayDate } from "./CustomFunction";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Dropdown from "./Dropdown.vue";
import InputCalender from "./InputCalender.vue";
import axios from "axios";
import { ToastProgrammatic as Toast } from "buefy";

let optionPageSize = [
  {
    label: "20",
    value: 20,
  },
  {
    label: "40",
    value: 40,
  },
  {
    label: "60",
    value: 60,
  },
  {
    label: "80",
    value: 80,
  },
  {
    label: "100",
    value: 100,
  },
];

export default {
  name: "List",
  props: [
    "dataSource",
    "loading",
    "handleSelect",
    "handleSelectAll",
    "bottomScroll",
    "onScroll",
    "handleChandePaginationSize",
    "currentLimit",
    "currentPage",
    "totalPage",
    "totalLimit",
    "fetchingSubmissionDataDetails",
    "handleRevoke",
    "handleDownloadAsExcel",
    "behaviorDataSource",
  ],
  components: {
    Loading,
    Dropdown,
    InputCalender,
  },
  data() {
    return {
      dataPageSize: optionPageSize,
      temporaryData: [],
      submissionData: [],
      startIndex: 1,
      selectedIndex: null,
      pointValue: null,
      multiplyValue: null,
      dayDate: "",
      activeDropdown: false,
      isCheckedAll: false,
      isAction: false,
      searchQuery: "",
    };
  },
  watch: {
    dataSource() {
      this.submissionData = this.dataSource;
      const checking = this.dataSource.filter((x) => x.checked);
      if (this.dataSource.length == 0) {
        this.selectedIndex = null;
      }
      if (checking.length == this.dataSource.length) {
        this.isCheckedAll = true;
      } else {
        this.isCheckedAll = false;
      }

      if (checking.length > 0) {
        this.isAction = true;
      } else {
        this.isAction = false;
      }
    },
    temporaryData() {
      this.submissionData = this.temporaryData;
    },
    searchQuery() {
      if (this.searchQuery.length > 0) {
        const filterName = this.submissionData.filter((x) =>
          x.studentName.toLowerCase().includes(this.searchQuery)
        );
        this.submissionData = filterName;
      } else {
        this.submissionData = this.dataSource;
      }
    },
  },
  computed: {
    renderTotalTable() {
      let self = this;
      let result = "";

      const itemsToShow = Array.from(
        { length: self.totalLimit },
        (_, i) => `Item ${i + 1}`
      );
      const size = self.currentLimit;
      const pages = Array.from(
        { length: Math.ceil(itemsToShow.length / size) },
        (_, i) => self.getPageLabel(itemsToShow.length, size, i)
      );

      const currentRange = self.getPageLabel(
        itemsToShow.length,
        size,
        self.currentPage - 1
      );
      const spliting = currentRange.split("to");

      self.startIndex = parseInt(spliting[0]);

      if (pages && pages.length > 0) {
        result = `Showing ${pages[self.currentPage - 1]} of ${
          self.totalLimit
        } entries`;
      }

      return result;
    },
  },
  methods: {
    displayInfo(data) {
      if (data.dataType == 2) {
        if (data.status == 2) {
          return "Late";
        } else {
          return "On-Time";
        }
      } else {
        return data.remarks == "" ? "-" : data.remarks;
        // if (data.remarks != undefined) {
        //   return data.remarks == "" ? "-" : data.remarks;
        // } else if (data.remarks2 != undefined) {
        //   return data.remarks2 == "" ? "-" : data.remarks2;
        // } else {
        //   return "No Remarks";
        // }
      }
    },
    handleExport() {
      this.handleDownloadAsExcel();
      this.activeDropdown = false;
    },
    handleDropwdownActions(value) {
      this.activeDropdown = value;
    },
    handleDropdownChange(property, value) {
      if (value) {
        let current = value.split("-");
        this.dayDate = current[0] + current[1] + current[2];
      }
    },
    async handleSave(data, index) {
      let payload = {
        email: localStorage.getItem("email"),
        password: localStorage.getItem("jwtTokenV2"),
        totalPoints: parseFloat(this.pointValue * this.multiplyValue),
        points: parseFloat(this.pointValue),
        multiply: parseFloat(this.multiplyValue),
        actionDate: this.dayDate,
        schoolID: data.schoolID,
        studentID: data.studentID._id,
        teacherID:
          data.teacherID._id == undefined ? data.teacherID : data.teacherID._id,
        awardedID: data._id,
        remarks: data.remarks,
        remarks2: "",
        status: data.status,
        isWeb: 1,
      };
      this.$swal.fire({
        title: "Loading ...",
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
        willOpen: async () => {
          await axios
            .post(
              "https://apiv2.studentqr.com/teacher/updateSubmission",
              payload
            )
            .then((response) => {
              this.$swal.close();
              this.$swal.hideLoading();
              if (response.status == 200) {
                this.selectedIndex = null;
                this.multiplyValue = null;
                this.pointValue = null;
                this.dayDate = "";
                this.$swal.showConfirmButton = false;
                this.$swal({
                  title: "Good job!",
                  icon: "success",
                  text: response.data.msg,
                  showCancelButton: false,
                  showCloseButton: false,
                  showConfirmButton: false,
                });

                setTimeout(() => {
                  this.handleUpdate(data, payload);
                }, 400);
              }
            })
            .catch((err) => {
              this.$swal.close();
              this.$swal.hideLoading();
              this.selectedIndex = null;
              this.multiplyValue = null;
              this.pointValue = null;
              this.dayDate = "";
              Toast.open({
                message: err,
                type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                duration: 5000,
              });
            });
        },
      });
      setTimeout(() => {
        this.$swal.close();
        this.$swal.hideLoading();
        this.selectedIndex = null;
        this.multiplyValue = null;
        this.pointValue = null;
        this.dayDate = "";
      }, 2200);
    },
    handleUpdate(data, newObj) {
      let newData = [...this.submissionData];
      let index = newData.findIndex((x) => x._id == data._id);
      let item = this.submissionData[index];

      let obj = {
        ...item,
        totalPoints: newObj.totalPoints,
        points: newObj.points,
        multiply: newObj.multiply,
        actionDate: newObj.actionDate,
      };

      newData.splice(index, 1, { ...item, ...obj });
      this.submissionData = [];
      this.temporaryData = newData;
    },
    handleCancel() {
      this.selectedIndex = null;
      this.multiplyValue = null;
      this.pointValue = null;
      this.dayDate = "";
    },
    handleEdit(data, index) {
      if (data !== null) {
        this.multiplyValue = data.multiply;
        this.pointValue = data.points;
        this.dayDate = data.actionDate;
      }
      this.selectedIndex = index;
    },
    getTotalPage(current) {
      let pages = Math.ceil(this.totalLimit / this.currentLimit);
      const start = current > 3 ? Math.max(2, current - 2) : 1;
      const end = Math.min(pages, current + 2);

      return this.range(start, end);
    },
    getPageStart(pageSize, pageNr) {
      return pageSize * pageNr;
    },
    getPageLabel(total, pageSize, pageNr) {
      let self = this;
      const start = Math.max(self.getPageStart(pageSize, pageNr), 0);
      const end = Math.min(self.getPageStart(pageSize, pageNr + 1), total);

      return `${start + 1} to ${end}`;
    },
    range(from, to, step = 1) {
      let i = from;
      const range = [];

      while (i <= to) {
        range.push(i);
        i += step;
      }
      return range;
    },
    d(date) {
      return displayDate(date);
    },

    viewImage(image) {
      window.open(`https://upload-face.studentqr.com/${image}`, "_blank");
    },
    viewLocation(latlng) {
      window.open(`https://maps.google.com/?q=${latlng}`, "_blank");
    },
    roundTo2DecimalPlaces(points) {
      //use lodash to round the points to 2 decimal places
      return _.round(points, 2);
      // return _.round(points, 2).toFixed(2)
    },
  },
};
</script>
<style>
.custom tbody {
  display: block;
  max-height: 60vh;
  overflow-y: scroll;
}
.custom thead,
.custom tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  font-size: 12px;
}

@media (max-width: 720px) {
  .custom table {
    width: 300vw !important;
  }
}
.bordered {
  border: 1px solid rgb(100 121 143 / 12%) !important;
  box-shadow: inset 0 -1px 0 0 rgb(100 121 143 / 12%);
}

.nbt {
  border-top: 0px !important;
}

.button.btn-light {
  border-color: #e4e4e4 !important;
  border: 0px;
}

.input.custom-input {
  border: 0px;
  box-shadow: unset;
}

.input.custom-input:focus,
.input.custom-input:active {
  border-color: #00d1b2 !important;
  border: 1px solid;
  border-radius: 6px;
}

.custom-justify-center {
  justify-content: center !important;
}

.custom-justify-start {
  justify-content: flex-start !important;
}

.custom-justify-end {
  justify-content: flex-end !important;
}

@media (max-width: 1024px) {
  .custom-justify-center {
    justify-content: flex-start !important;
  }

  .custom-justify-start {
    justify-content: flex-start !important;
  }

  .custom-justify-end {
    justify-content: flex-start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OverallReporting/List.vue